import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { COACH } from "helpers/viewContent";
import { getDetail_ } from "store/services/commonService";
import { DATE_FORMAT, DATE_FORMAT_TIME } from "helpers/common";
import { PRODUCT_IMG } from "utils/constant";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";

const Detail = ({ dispatch, match }) => {
  let editkey = match.params.id;
  const [editData, setEditData] = useState({});
  const [playingSurface, setPlayingSurface] = useState([]);

  async function getData() {
    try {
      let query = {
        url: "coach/view",
        id: editkey,
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getDetail_(query));
      setEditData(res?.body);
      setPlayingSurface(
        res?.body ? JSON.parse(res?.body.preferred_playing_surface) : []
      );
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }

  useEffect(() => {
    if (editkey) {
      getData();
    }
  }, []);
  return (
    <>
      <Helmet title={COACH.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-account-multiple menu-icon"></i>
          </span>{" "}
          {COACH.CURRENT_VIEW}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.coach}>Coach</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Detail
            </li>
          </ol>
        </nav>
      </div>

      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4>
                <b>Personal info </b>
              </h4>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      First Name
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.name ? editData?.name : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Last Name</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.last_name ? editData?.last_name : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Email</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.email ? editData?.email : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Date of Birth
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.birth_date
                        ? DATE_FORMAT(editData?.birth_date)
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Phone</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.phone
                        ? `${editData?.country_code} ${editData?.phone}`
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Preferred Age Range
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.preferred_age
                        ? `${editData?.preferred_age} years`
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Gender</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.gender
                        ? editData.gender === "1"
                          ? "Male"
                          : editData?.gender === "2"
                          ? "Female"
                          : editData?.gender === "3"
                          ? "Other"
                          : "N/A"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Preferred Playing Surfaces
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {playingSurface?.length > 0 &&
                        playingSurface?.map((surface) => {
                          return <>{surface}, </>;
                        })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Player Statistics
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.player_statistics
                        ? `${editData?.player_statistics} `
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Playing Style
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.player_style
                        ? `${editData?.player_style} `
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Nationality
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.nationality ? editData?.nationality : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <h4>
                <b>Physical Attributes : </b>
              </h4>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Height</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.height ? `${editData?.height} inch` : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Weight</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.weight ? `${editData?.weight} kg` : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Status</label>
                    <div className="col-sm-6 col-form-label">
                      <p
                        className={`badge badge-gradient-${
                          editData?.status == 1 ? "success" : "danger"
                        }`}
                      >
                        {editData?.status == 1 ? "Active" : "Inactive"}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Location</label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.location ? `${editData?.location}` : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Number of Followers
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.number_of_followers
                        ? `${editData?.number_of_followers}`
                        : "0"}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Number of Following
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.number_of_following
                        ? `${editData?.number_of_following}`
                        : "0"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">Image</label>
                    <div className="col-sm-6 col-form-label">
                      <a
                        href={editData?.image ? `${editData?.image}` : "#"}
                        target="_blank"
                      >
                        <img
                          src={`${
                            editData?.image ? editData?.image : PRODUCT_IMG
                          }`}
                          className="mb-2 rounded img-view"
                          alt="image"
                        />
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group row">
                    <label className="col-sm-6 col-form-label">
                      Created At
                    </label>
                    <div className="col-sm-6 col-form-label">
                      {editData?.created_at
                        ? DATE_FORMAT_TIME(editData?.created_at)
                        : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <h4>
                <b>Bio : </b>
              </h4>
              <div className="col-md-12">
                <div className="form-group">
                  <div className="col-sm-12 col-form-label">
                    {editData?.bio ? editData?.bio : "N/A"}
                  </div>
                </div>
              </div>
              <hr />
              {editData?.academy_details?.length > 0 && (
                <>
                  <h4>
                    <b>Academy Details </b>
                  </h4>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th> Academy Name </th>
                          <th> Academy Image </th>
                          <th> Academy Location </th>
                          <th> Academy Description </th>
                        </tr>
                      </thead>
                      <tbody>
                        {editData?.academy_details?.length > 0 &&
                          editData?.academy_details?.map((val, i) => {
                            return (
                              <>
                                <tr key={i}>
                                  <td>
                                    <h6>{val.academy?.academy_name}</h6>
                                  </td>
                                  <td>
                                    <a
                                      href={
                                        val?.academy?.academy_image
                                          ? `${val?.academy?.academy_image}`
                                          : "#"
                                      }
                                      target="_blank"
                                    >
                                      <img
                                        src={
                                          val?.academy?.academy_image_thumb !==
                                          ""
                                            ? `${val?.academy?.academy_image_thumb}`
                                            : PRODUCT_IMG
                                        }
                                        className="custom-img"
                                      />
                                    </a>{" "}
                                  </td>
                                  <td>
                                    <h6>{val.academy?.academy_location}</h6>
                                  </td>

                                  <td>
                                    <h6>
                                      {val.academy?.academy_description
                                        ? val.academy?.academy_description
                                        : ""}
                                    </h6>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Detail);
